import React from 'react';
import clsx from 'clsx';

type Variant = 'success' | 'warning' | 'danger' | 'info' | 'neutral';

const variantMap: Record<Variant, string> = {
  success: 'bg-success-soft text-success',
  warning: 'bg-warning-soft text-warning',
  danger:  'bg-danger-soft text-danger',
  info:    'bg-info-soft text-info',
  neutral: 'bg-surface-alt text-text-muted',
};

const statusToVariant: Record<string, Variant> = {
  active:    'success',
  trial:     'warning',
  suspended: 'danger',
  expired:   'neutral',
};

interface Props {
  status: string;
  label?: string;
  variant?: Variant;
}

export const StatusPill: React.FC<Props> = ({ status, label, variant }) => {
  const v = variant ?? statusToVariant[status.toLowerCase()] ?? 'neutral';
  return (
    <span className={clsx(
      'inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-semibold',
      variantMap[v],
    )}>
      <span className={clsx('h-1.5 w-1.5 rounded-full', {
        'bg-success': v === 'success',
        'bg-warning': v === 'warning',
        'bg-danger': v === 'danger',
        'bg-info': v === 'info',
        'bg-text-muted': v === 'neutral',
      })} />
      {label ?? status}
    </span>
  );
};
